//#region FILTRO_STORE

const filtro = {
  namespaced: true,
  state: {
    familia: 0,
    produto: 0,
    variacao: 0,      
    exibeInativo: false,    
  },
  getters: {
    getFamilia: state => state.familia,
    getProduto: state => state.produto,
    getVariacao: state => state.variacao,        
    getExibeInativo: state => state.exibeInativo,
  },
  mutations: {
    setFamilia: (state, payload) => state.familia = payload,
    setProduto: (state, payload) => state.produto = payload,
    setVariacao: (state, payload) => state.variacao = payload,         
    setExibeInativo: (state, payload) => state.exibeInativo = payload,
  }
}

const data = {
  namespaced: true,
  state: {
    producao: [],
    carregado : false,
    numberLoaded : 0,
    linhaSelecionadaFixa: 0,
    numberLoadedLinhaSelecionada: 0,
  },
  getters: {
    getProducao: state => state.producao,
    getCarregado: state => state.carregado,
    getNumberLoaded: state => state.numberLoaded,
    getLinhaSelecionadaFixa: state => state.linhaSelecionadaFixa,    
    getNumberLoadedLinhaSelecionada: state => state.numberLoadedLinhaSelecionada,
  },
  mutations: {
    setProducao: (state, payload) => state.producao = payload,
    setCarregado: (state, payload) => state.carregado = payload,
    setNumberLoaded: (state, payload) => state.numberLoaded = payload,
    setLinhaSelecionadaFixa: (state, payload) => state.linhaSelecionadaFixa = payload,
    setNumberLoadedLinhaSelecionada: (state, payload) => state.numberLoadedLinhaSelecionada = payload,
  }
};

const ProducaoStore = new window.Vuex.Store({
  modules: {
    filtro: filtro,    
    data : data
  },
});

export default ProducaoStore;
